import { useQuery } from "@tanstack/react-query";
import { getCardTransactionsAvailability } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const CARD_TRANSACTIONS_AVAILABILITY_QUERY_KEY =
  "CARD_TRANSACTIONS_AVAILABILITY";

export const cardTransactionsAvailabilityKeys = {
  all: [CARD_TRANSACTIONS_AVAILABILITY_QUERY_KEY],
};

/**
 * Whether the current merchant should see the "Karty" tab (ZS-1291 FR-UI-6): true only when the merchant is on an
 * enabled OrbitL price-list AND has at least one paired terminal PayPoint. The rule lives server-side; the FE just
 * reads the boolean. Cached for 5 minutes — eligibility changes rarely (price-list / terminal onboarding).
 */
export const useCardTransactionsAvailability = () =>
  useQuery({
    queryKey: cardTransactionsAvailabilityKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getCardTransactionsAvailability(),
    ),
    staleTime: 5 * MS_TIME.minute,
  });
